var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSignOut = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7E869E",
    d: "m22 12 .78-.625.5.625-.5.625zm-9 1a1 1 0 1 1 0-2zm5.78-6.625 4 5-1.56 1.25-4-5zm4 6.25-4 5-1.56-1.25 4-5zM22 13h-9v-2h9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E869E",
    strokeWidth: 2,
    d: "M14 8.132v-.743c0-1.619 0-2.428-.474-2.987s-1.272-.693-2.868-.96l-1.672-.278c-3.243-.54-4.864-.81-5.925.088C2 4.151 2 5.795 2 9.082v5.835c0 3.288 0 4.932 1.06 5.83 1.062.9 2.683.63 5.926.089l1.672-.279c1.596-.266 2.394-.399 2.868-.958.474-.56.474-1.37.474-2.988v-.545"
  })));
};
export default SvgSignOut;